export default "__VITE_ASSET__07DIr76r__"